// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZTYA","questions":"styles_questions__1DPwW","footer":"styles_footer__1-ih2"};